<section class="welcome-panel" aria-label="Welcome state">
  <h1 class="welcome-panel__hero">{{ 'certify.chatbot.welcome.title' | translate }}</h1>
  <p class="welcome-panel__subtitle">{{ 'certify.chatbot.welcome.subtitle' | translate }}</p>

  <div
    class="welcome-panel__cards"
    *ngIf="quickQuestions.length; else emptyState"
    role="list"
    aria-label="Suggestion cards"
  >
    <talk-to-your-data-suggestion-card
      *ngFor="let question of quickQuestions"
      role="listitem"
      [title]="question.title"
      [description]="question.description"
      (selected)="onSuggestionSelected(question)"
    ></talk-to-your-data-suggestion-card>
  </div>
  <p class="welcome-panel__prompt">{{ 'certify.chatbot.welcome.prompt' | translate }}</p>
  <p class="welcome-panel__warning">{{ 'certify.chatbot.welcome.warning' | translate }}</p>

  <ng-template #emptyState>
    <p class="welcome-panel__empty">{{ 'certify.chatbot.welcome.empty' | translate }}</p>
  </ng-template>
</section>
